<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" style="min-width: 580px">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <WarningIcon
            style="min-height: 50px; min-width: 50px"
            class="warning-icon"
          />
          <h1
            class="modal-title fs-1 pt-2"
            style="line-height: 1.2; margin-left: 15px"
            v-html="popupTitle"
          ></h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="margin-right: 10px; margin-top: -50px"
          ></button>
        </div>
        <div class="modal-body p-3 pt-1 pb-0" style="margin-left: 10px">
          <p
            class="p-text-grey mb-1"
            style="font-weight: bold; color: black"
            v-html="popupSubtitle"
          ></p>
          <p
            class="p-text-grey mb-3"
            style="color: black"
            v-html="popupBody"
          ></p>
        </div>
        <div
          class="d-flex justify-content-start modal-footer border-top-0 mt-2"
          style="margin-left: 10px"
        >
          <a href="https://simpleloyalty.com/#/support" target="_blank">
            <button
              style="height: 40px; font-size: 13px; font-weight: normal"
              class="btn btn-customs py-1 px-3 me-2 me-lg-0"
            >
              Contact A Relationship Manager
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import WarningIcon from "@/pages/reusables/WarningIcon/WarningIcon.vue";
import { useNotificationConfig } from "@/stores/notificationConfig.js";

// Props for dynamic specification
const props = defineProps({
  specification: {
    type: String,
    required: true,
  },
});

// Store to manage notification config data
const notification = useNotificationConfig();

// Dynamically get popup content based on the passed specification
const popupTitle = computed(() => {
  const config = notification.notificationConfig.find(
    (item) => item.specification === props.specification
  );
  return config?.popupTitle || "Default Title";
});

const popupSubtitle = computed(() => {
  const config = notification.notificationConfig.find(
    (item) => item.specification === props.specification
  );
  return config?.popupSubtitle || "Default Subtitle";
});

const popupBody = computed(() => {
  const config = notification.notificationConfig.find(
    (item) => item.specification === props.specification
  );
  return config?.popupBody || "Default body content";
});

// Dynamic modalId based on specification
const modalId = computed(() => `modal_${props.specification}`);
</script>
